import { LinkedComponent } from '@ardoq/api-types';
import { SimpleReferenceModel } from '@ardoq/data-model';

export type GetAddToMaps = {
  referenceMap: Map<string, SimpleReferenceModel>;
  sourceMap: Map<string, LinkedComponent[]>;
  targetMap: Map<string, LinkedComponent[]>;
};

export type AddToMaps = {
  referenceId: string;
  sourceId: string;
  targetId: string;
};

export const getAddToMaps =
  ({ referenceMap, sourceMap, targetMap }: GetAddToMaps) =>
  ({ referenceId, sourceId, targetId }: AddToMaps) => {
    {
      referenceMap.set(referenceId, { sourceId, targetId });
      let targetIds = sourceMap.get(sourceId);
      if (!targetIds) {
        targetIds = [];
        sourceMap.set(sourceId, targetIds);
      }
      targetIds.push({ componentId: targetId, referenceId });
      let sourceIds = targetMap.get(targetId);
      if (!sourceIds) {
        sourceIds = [];
        targetMap.set(targetId, sourceIds);
      }
      sourceIds.push({ componentId: sourceId, referenceId });
    }
  };
